//调查问卷
const surveyBox               = () => import('@/components/survey/surveyBox');
const surveyList              = () => import('@/components/survey/surveyList');
const surveyPaperList         = () => import('@/components/survey/surveyPaperList');
const addSurvey               = () => import('@/components/survey/survey/addSurvey');
const editSurvey              = () => import('@/components/survey/survey/editSurvey');
const surveyShare             = () => import('@/components/survey/survey/surveyShare');
const surveyStats             = () => import('@/components/survey/survey/surveyStats');
const surveyTable             = () => import('@/components/survey/survey/surveyTable');
const addSurveyPaper          = () => import('@/components/survey/paper/addSurveyPaper');
const editSurveyPaper         = () => import('@/components/survey/paper/editSurveyPaper');
const editSurveyPaperQuestion = () => import('@/components/survey/paper/editSurveyPaperQuestion');
const surveyPaperCategory     = () => import('@/components/survey/category/surveyPaperCategory');


export default{
    path: '/surveyBox',
    name: 'surveyBox',
    component: surveyBox,
    children: [
        { path: 'addSurvey', component: addSurvey, name: 'addSurvey' },
        { path: 'editSurvey', component: editSurvey, name: 'editSurvey' },
        { path: 'surveyList', component: surveyList, name: 'surveyList' },
        { path: 'addSurveyPaper', component: addSurveyPaper, name: 'addSurveyPaper' },
        { path: 'editSurveyPaper', component: editSurveyPaper, name: 'editSurveyPaper' },
        { path: 'surveyShare', component: surveyShare, name: 'surveyShare' },
        { path: 'surveyStats', component: surveyStats, name: 'surveyStats' },
        { path: 'surveyTable', component: surveyTable, name: 'surveyTable' },
        { path: 'editSurveyPaperQuestion', component: editSurveyPaperQuestion, name: 'editSurveyPaperQuestion' },
        { path: 'surveyPaperList', component: surveyPaperList, name: 'surveyPaperList' },
        { path: 'surveyPaperCategory', component: surveyPaperCategory, name: 'surveyPaperCategory' },
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/survey.js